var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 1.33325C4.33331 1.33325 1.33331 4.33325 1.33331 7.99992C1.33331 11.6666 4.33331 14.6666 7.99998 14.6666C11.6666 14.6666 14.6666 11.6666 14.6666 7.99992C14.6666 4.33325 11.6666 1.33325 7.99998 1.33325ZM7.99998 13.3333C5.06665 13.3333 2.66665 10.9333 2.66665 7.99992C2.66665 5.06659 5.06665 2.66659 7.99998 2.66659C10.9333 2.66659 13.3333 5.06659 13.3333 7.99992C13.3333 10.9333 10.9333 13.3333 7.99998 13.3333Z",
    fill: "#8AB1BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06662 4.8667H7.99996C7.33329 4.8667 6.73329 5.20003 6.39996 5.73337C6.13329 6.0667 6.19996 6.4667 6.53329 6.6667C6.86662 6.8667 7.26662 6.80003 7.46662 6.4667C7.59996 6.2667 7.79996 6.20003 7.99996 6.20003H8.06662C8.39996 6.20003 8.66662 6.4667 8.66662 6.80003C8.66662 7.0667 8.46662 7.33337 8.26662 7.40003L7.79996 7.53337C7.53329 7.60003 7.33329 7.8667 7.33329 8.13337V8.6667C7.33329 9.0667 7.59996 9.33337 7.99996 9.33337C8.33329 9.33337 8.66662 9.0667 8.66662 8.73337C9.46662 8.4667 9.99996 7.73337 9.99996 6.8667C9.99996 5.80003 9.13329 4.8667 8.06662 4.8667Z",
    fill: "#8AB1BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.3333C8.36817 11.3333 8.66665 11.0349 8.66665 10.6667C8.66665 10.2985 8.36817 10 7.99998 10C7.63179 10 7.33331 10.2985 7.33331 10.6667C7.33331 11.0349 7.63179 11.3333 7.99998 11.3333Z",
    fill: "#8AB1BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6a8d600025238d4049c09a79535ef50b.svg";
export { ForwardRef as ReactComponent };